// tsc does not recognize jsx extension therefor renaming to tsx
import AuthProvider from '../providers/AuthProvider';

/**
 * Starts logout request
 * @returns {AuthConsumer}
 * @constructor
 */
export const SignOut = () => AuthProvider.createConsumer('signOutRequest', 'Ajax.signingOutMessage');
